import { render, staticRenderFns } from "./blockS2.vue?vue&type=template&id=ffa32800&"
import script from "./blockS2.vue?vue&type=script&lang=js&"
export * from "./blockS2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports